<template>
    <div class="guide-builder-inspect-panel">
        <div class="guide-builder-inspect-panel__header">
            <div class="guide-builder-inspect-panel__header-left">
                <pendo-icon-button
                    icon="arrow-left"
                    icon-size="16"
                    :aria-label="$t('guideBuilderInspectPanel.Back')"
                    @click="$emit('back')" />
                <span class="guide-builder-inspect-panel__title">{{ headerTitle }}</span>
            </div>
        </div>
        <pendo-divider height="1px" />
        <div class="guide-builder-inspect-panel__content">
            <template v-if="selectedBlock">
                <div class="guide-builder-inspect-panel__block-info">
                    <p class="guide-builder-inspect-panel__empty-title">
                        {{ blockMessage.title }}
                    </p>
                    <p class="guide-builder-inspect-panel__empty-description">
                        {{ blockMessage.description }}
                    </p>
                </div>
            </template>
            <template v-else>
                <div class="guide-builder-inspect-panel__empty-state">
                    <p class="guide-builder-inspect-panel__empty-title">
                        {{ $t('guideBuilderInspectPanel.Select a building block to edit') }}
                    </p>
                    <p class="guide-builder-inspect-panel__empty-description">
                        {{ $t('guideBuilderInspectPanel.Click a building block in the guide preview to edit it here.') }}
                    </p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { PendoDivider, PendoIconButton } from '@pendo/components';

export default {
    name: 'GuideBuilderInspectPanel',
    components: {
        PendoDivider,
        PendoIconButton,
    },
    props: {
        selectedBlock: {
            type: Object,
            default: null,
        },
    },
    emits: ['back'],
    computed: {
        headerTitle () {
            if (!this.selectedBlock) return this.$t('guideBuilderInspectPanel.Inspect');

            const stepNumber = this.selectedBlock.stepIndex + 1;

            return this.$t('guideBuilderInspectPanel.Step {stepNumber}: Edit {blockType}', {
                stepNumber,
                blockType: this.getBlockTypeLabel(this.selectedBlock?.type),
            });
        },
        blockMessage () {
            const typeLabel = this.getBlockTypeLabel(this.selectedBlock?.type);

            return {
                title: this.$t('guideBuilderInspectPanel.This {type} can\'t be edited here', { type: typeLabel }),
                description: this.$t('guideBuilderInspectPanel.To edit this {type}, first save the guide, then open it in the Visual Design Studio.', { type: typeLabel }),
            };
        },
    },
    methods: {
        getBlockTypeLabel (type) {
            const blockTypes = {
                text: this.$t('guideBuilderInspectPanel.text'),
                button: this.$t('guideBuilderInspectPanel.button'),
            };

            return blockTypes[type] || this.$t('guideBuilderInspectPanel.element');
        },
    },
};
</script>

<style lang="less" scoped>
.guide-builder-inspect-panel {
    display: flex;
    flex-direction: column;
    width: 400px;
    flex-shrink: 0;
    background-color: var(--palette-gray-0);
    border-left: 1px solid var(--palette-gray-40);
    height: 100%;
    overflow-y: auto;

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 12px;
        height: 56px;
    }

    &__header-left {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    &__title {
        font-size: 14px;
        font-weight: 600;
        color: var(--palette-gray-100);
    }

    &__content {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    &__empty-state,
    &__block-info {
        padding: 24px 16px;
    }

    &__empty-title {
        font-size: 14px;
        font-weight: 600;
        color: var(--palette-gray-100);
        margin: 0 0 4px 0;
    }

    &__empty-description {
        font-size: 13px;
        color: var(--palette-gray-70);
        margin: 0;
        line-height: 1.5;
    }
}
</style>
